import React from 'react';
import { WebsiteDesignProps } from './types';
// Icons not currently used but available: TrendingUp, PieChart, Users
import { Button } from "@/components/ui/button";

const BusinessSchool: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Global School of Business";

    return (
        <div className="bg-white min-h-screen font-sans text-slate-900">
            <nav className="bg-[#002855] text-white p-6 sticky top-0 z-50">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="font-bold text-2xl tracking-tighter uppercase">
                        {schoolName}
                    </div>
                    <div className="hidden md:flex gap-8 text-sm font-bold uppercase tracking-widest text-blue-200">
                        <a href="#" className="hover:text-white">MBA</a>
                        <a href="#" className="hover:text-white">Executive</a>
                        <a href="#" className="hover:text-white">Faculty</a>
                        <a href="#" className="hover:text-white">Careers</a>
                    </div>
                    <Button className="bg-yellow-500 text-[#002855] hover:bg-yellow-400 font-bold uppercase text-xs tracking-widest px-6">
                        Apply
                    </Button>
                </div>
            </nav>

            <header className="relative py-24 bg-slate-50">
                <div className="container mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
                    <div>
                        <h1 className="text-5xl md:text-7xl font-extrabold text-[#002855] mb-6 leading-none">
                            Lead The <br/> Market.
                        </h1>
                        <div className="h-2 w-24 bg-yellow-500 mb-8"></div>
                        <p className="text-xl text-slate-600 mb-10 leading-relaxed">
                            Developing ethical leaders who create value and drive sustainable growth in a global economy.
                        </p>
                        <div className="flex gap-4">
                            <Button className="bg-[#002855] text-white hover:bg-blue-900 h-14 px-8 font-bold text-lg">
                                View Programs
                            </Button>
                        </div>
                    </div>
                    <div>
                        <div className="border border-slate-200 bg-white p-8 shadow-xl">
                             <div className="flex items-center gap-4 mb-6 pb-6 border-b border-slate-100">
                                 <div className="w-16 h-16 bg-[#002855] flex items-center justify-center text-white font-bold text-2xl">
                                     #1
                                 </div>
                                 <div className="text-slate-700 font-medium">
                                     Ranked top business school for entrepreneurship three years running.
                                 </div>
                             </div>
                             <div className="grid grid-cols-2 gap-4">
                                 <div className="text-center p-4 bg-slate-50">
                                     <div className="text-2xl font-bold text-[#002855]">$145k</div>
                                     <div className="text-xs uppercase tracking-wide text-slate-500 mt-1">Avg Starting Salary</div>
                                 </div>
                                 <div className="text-center p-4 bg-slate-50">
                                     <div className="text-2xl font-bold text-[#002855]">94%</div>
                                     <div className="text-xs uppercase tracking-wide text-slate-500 mt-1">Employment Rate</div>
                                 </div>
                             </div>
                        </div>
                    </div>
                </div>
            </header>

            <section className="py-20 bg-white container mx-auto px-6">
                <div className="flex flex-wrap gap-4 justify-center">
                    {['Finance', 'Marketing', 'Operations', 'Strategy', 'Analytics', 'Economics'].map((tag, i) => (
                        <span key={i} className="px-6 py-3 border border-slate-200 text-slate-600 font-bold uppercase tracking-wider text-sm hover:bg-[#002855] hover:text-white hover:border-[#002855] transition-colors cursor-pointer">
                            {tag}
                        </span>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default BusinessSchool;
